import { render, staticRenderFns } from "./SpaceMembersList.vue?vue&type=template&id=b41c82b4&"
import script from "./SpaceMembersList.vue?vue&type=script&lang=js&"
export * from "./SpaceMembersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports